import {
    Create,
    required,
    TextInput,
    BooleanInput,
    Link, useCreate, useNotify, useRedirect, TabbedForm, FormTab, FunctionField
} from "react-admin";
import * as React from "react";
import {useState} from "react";
import {EBooleanStatuses, EBooleanStatusesNumber} from "../../../Const/Enums";
import {useDispatch} from "react-redux";
import setLoadStatus from "../../../Store/LoaderReducer";
import {Calendar} from "react-multi-date-picker";
import {convertedDate, convertedDateWithTime} from "../../../Functions/ConvertedDate";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

export const CreateEvent = () => {
    const [create] = useCreate();
    const notify = useNotify();
    const redirect = useRedirect();
    const dispatch = useDispatch();

    const onDateChange = (e, period) => {

        console.log('---------');
        console.log(e);

        if (e.value && e.value.unix) {
            const date = new Date(e.value.unix * 1000);
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            formData[period] = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${hours}:${minutes}`;
        }
    }

    const [formData] = useState({
        name: '',
        start_date: '',
        end_date: '',
   });


    const eventCreate = () => {
        let startDate = formData.start_date || document.getElementById('start_date').value;
        let endDate = formData.end_date || document.getElementById('end_date').value;

        if(!startDate.length) {
            notify('Start date is required', 'warning');
            return ;
        }

        if(!endDate.length) {
            notify('End date is required', 'warning');
            return ;
        }

        if(startDate.length && endDate.length) {
            let startD = new Date(startDate);
            let endD = new Date(endDate);
            if (startD.getTime() > endD.getTime()) {
                notify("Start date can't be earlier than end date", 'warning');
                return ;
            }
        }

        dispatch(setLoadStatus(true));
        if (!formData.name.length) {
            document.querySelector('.name').classList.add('error');

            dispatch(setLoadStatus(false));
            return;
        }

        create('events/general', {data: {
                name: formData.name,
                start_date: formData.start_date || document.getElementById('start_date').value,
                end_date: formData.end_date || document.getElementById('end_date').value
            }}, {
            onSuccess: (res) => {
                dispatch(setLoadStatus(false));
                redirect(`/events/general/${res.id}/en`);
                notify('Event general created');
            },
            onError: (res) => {
                dispatch(setLoadStatus(false));
                notify(res.message, 'warning');
            }
        });
    };

    const Save = () => {
        return (
            <div className="dailyActionToolbar">
                <Link to="/events/general" className="button bar-purple-button">Cancel</Link>
                <button
                    onClick={eventCreate}
                    className="button bar-gradient-button"
                    type="button"
                >
                    <span>Save</span>
                </button>
            </div>
        );
    }

    const nameChange = (e) => {
        if (document.querySelector('.name').classList.contains('error')) {
            document.querySelector('.name').classList.remove('error');
        }
        formData.name = e.target.value;
    }

    return (
        <>
            <h2 className="dailyTitle">New Event</h2>
            <Create title="Create Event">
                <TabbedForm className="tabbedForm" record={formData} toolbar={<></>}>
                    <FormTab label="General">
                        <div className="tabbedFormWrap">
                            <TextInput className="formFields name" label="Name" name="name" source="name" fullWidth id="name" validate={required()} onChange={(e) => {nameChange(e)}} multiline />
                            <span className="showDateLabel">Start Date</span>
                            <FunctionField source="start_date" render={(record) => {
                                return (
                                    <>
                                        <Calendar
                                            value={record.start_date ? convertedDateWithTime(record.start_date) : null}
                                            onPropsChange={(e) => {
                                                onDateChange(e, 'start_date')
                                            }}
                                            format="MM/DD/YYYY HH:mm"
                                            plugins={[<TimePicker position="bottom" hideSeconds />]}
                                            minDate="2000/01/01"
                                            maxDate="3000/12/31"
                                        />
                                        <input type="hidden" id="start_date"
                                               value={record.start_date && !formData.start_date ? convertedDate(record.start_date) : formData.start_date}/>
                                    </>
                                );
                            }}/>
                            <span className="showDateLabel showDateLabelEnd">End Date</span>
                            <FunctionField source="end_date" render={(record) => {
                                return (
                                    <>
                                        <Calendar
                                            value={record.end_date ? convertedDateWithTime(record.end_date) : null}
                                            onPropsChange={(e) => {
                                                onDateChange(e, 'end_date')
                                            }}
                                            format="MM/DD/YYYY HH:mm"
                                            plugins={[<TimePicker position="bottom" hideSeconds />]}
                                            minDate="2000/01/01"
                                            maxDate="3000/12/31"
                                        />
                                        <input type="hidden" id="end_date"
                                               value={record.end_date && !formData.end_date ? convertedDate(record.end_date) : formData.end_date}/>
                                    </>
                                );
                            }}/>
                        </div>
                        <Save />
                    </FormTab>
                    <FormTab label="EN" path="en" disabled={true}>
                        <>
                            <p>No Data</p>
                        </>
                    </FormTab>
                    <FormTab label="PT" path="pt" disabled={true}>
                        <>
                            <p>No Data</p>
                        </>
                    </FormTab>
                    <FormTab label="DE" path="de" disabled={true}>
                        <>
                            <p>No Data</p>
                        </>
                    </FormTab>
                </TabbedForm>
            </Create>
        </>
    );
}